import React from "react";

const Sponsors = () => {
  return (
    <div className="sponsors">
      <img src="\assets\Logo Blizz.png" alt="Logo Blizz" />
      <img src="\assets\Logo BPGO.png" alt="Logo Banque Populaire" />
      <img src="\assets\Logo Lyf.jpg" alt="Logo Lyf" />
      <img src="\assets\Logo Garden.png" alt="Logo Le Garden" />
    </div>
  );
};

export default Sponsors;
